import { DomeComponent, DomeManipulator, React } from "@lexriver/dome";
import { Settings } from "../../Settings";
import { IBasket } from "../Basket/IBasket";
import { EnumCurrency } from "../enums/EnumCurrency";
import { GlobalBasket } from "../GlobalBasket";
import { ServerSettings } from "../server-queries/ServerSettings";
import css from './Basket.m.scss'
import { ButtonBack } from "./ButtonBack";

interface Attrs{

}

export class BasketRemainderWarning extends DomeComponent<Attrs>{
    render(){
        return <div></div>
    }
    async afterRender() {
        GlobalBasket.onBasketUpdateEvent.subscribe(async () => {
            if (DomeManipulator.isInDom(this.rootElement) == false) return { unsubscribe: true }
            this.scheduleUpdate()

        })

        this.scheduleUpdate()
    }

    async updateAsync(){
        // console.log('BasketRemainderWarning: updateAsync()')
        // if(Settings.checkIfDomainIsShop()){
        //     console.log('BasketRemainderWarning: domain is shop')
        //     await this.hideAsync()
        //     return
        // }

        const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()
        const basketStats = await basket.getStatsAsync({getJsonOrderItems:false})


        if(!basketStats.wholesaleSum) return
        const minWholesaleOrder = Number(await ServerSettings.getOnlyValueAsync('min-wholesale-order'))
        const remainder = minWholesaleOrder-basketStats.wholesaleSum

        if(remainder <= 0){
            await this.hideAsync()

        } else {
            await this.showAsync(minWholesaleOrder, remainder)

        }
    }

    async hideAsync(){
        await DomeManipulator.replaceAllChildrenAsync(this.rootElement, <span></span>)
    }

    async showAsync(minWholesaleOrder:number, remainder:number){
        await DomeManipulator.replaceAllChildrenAsync(this.rootElement, 
            <div class={css.remainder}>
                <div class={css.text}>
                    Вы пока еще не набрали минимальную сумму оптового заказа:&nbsp;
                    <strong>{Settings.formatNumberToPrice(minWholesaleOrder, EnumCurrency.RUB)}</strong>,<br />
                    Вам еще осталось набрать товаров на сумму: <strong>{Settings.formatNumberToPrice(remainder, EnumCurrency.RUB)}</strong>
                </div>
                <div class={css.buttonBackContainer}>
                    <ButtonBack text="вернуться в каталог"></ButtonBack>
                </div>
            </div>)
    }



}